export default {"src":"/_next/static/media/key-solid.a96dd6aa.svg","height":512,"width":512};